export const getStaysLoading = (state: any) => state.stays.loading;
export const getStays = (state: any) => state.stays.data;
export const getSettings = (state: any) => state.stays.settings;
export const getStaysError = (state: any) => state.stays.error;
